const e = {
  primitive: {
    color: {
      twilight: {
        100: {
          value: "#fafafb",
          type: "color",
          description: ""
        },
        200: {
          value: "#f5f6f7",
          type: "color",
          description: ""
        },
        300: {
          value: "#e6e8ea",
          type: "color",
          description: ""
        },
        400: {
          value: "#d1d5d9",
          type: "color",
          description: ""
        },
        500: {
          value: "#9ca3ad",
          type: "color",
          description: ""
        },
        600: {
          value: "#6b7786",
          type: "color",
          description: ""
        },
        700: {
          value: "#4d5b6d",
          type: "color",
          description: ""
        },
        800: {
          value: "#38485c",
          type: "color",
          description: ""
        },
        900: {
          value: "#1f3047",
          type: "color",
          description: ""
        },
        1e3: {
          value: "#00142e",
          type: "color",
          description: ""
        },
        1100: {
          value: "#001229",
          type: "color",
          description: ""
        },
        1200: {
          value: "#001025",
          type: "color",
          description: ""
        },
        "000": {
          value: "#ffffff",
          type: "color",
          description: ""
        }
      },
      fordBlue: {
        100: {
          value: "#e6e6ef",
          type: "color",
          description: ""
        },
        200: {
          value: "#cccede",
          type: "color",
          description: ""
        },
        300: {
          value: "#b3b5ce",
          type: "color",
          description: ""
        },
        400: {
          value: "#999dbd",
          type: "color",
          description: ""
        },
        500: {
          value: "#8084ad",
          type: "color",
          description: ""
        },
        600: {
          value: "#666b9d",
          type: "color",
          description: ""
        },
        700: {
          value: "#4d538c",
          type: "color",
          description: ""
        },
        800: {
          value: "#333a7c",
          type: "color",
          description: ""
        },
        900: {
          value: "#1a226b",
          type: "color",
          description: ""
        },
        1e3: {
          value: "#00095b",
          type: "color",
          description: ""
        },
        1100: {
          value: "#000852",
          type: "color",
          description: ""
        },
        1200: {
          value: "#000749",
          type: "color",
          description: ""
        }
      },
      grabber: {
        100: {
          value: "#e8e6fe",
          type: "color",
          description: ""
        },
        200: {
          value: "#d1ccfd",
          type: "color",
          description: ""
        },
        300: {
          value: "#b9b3fc",
          type: "color",
          description: ""
        },
        400: {
          value: "#a299fb",
          type: "color",
          description: ""
        },
        500: {
          value: "#8b80f9",
          type: "color",
          description: ""
        },
        600: {
          value: "#7466f8",
          type: "color",
          description: ""
        },
        700: {
          value: "#5d4df7",
          type: "color",
          description: ""
        },
        800: {
          value: "#484dee",
          type: "color",
          description: ""
        },
        900: {
          value: "#2e19f5",
          type: "color",
          description: ""
        },
        1e3: {
          value: "#1700f4",
          type: "color",
          description: ""
        },
        1100: {
          value: "#1500dc",
          type: "color",
          description: ""
        },
        1200: {
          value: "#1200c3",
          type: "color",
          description: ""
        }
      },
      amber: {
        100: {
          value: "#fcf2e6",
          type: "color",
          description: ""
        },
        200: {
          value: "#f8e4cc",
          type: "color",
          description: ""
        },
        300: {
          value: "#f5d7b3",
          type: "color",
          description: ""
        },
        400: {
          value: "#f1ca99",
          type: "color",
          description: ""
        },
        500: {
          value: "#eebc80",
          type: "color",
          description: ""
        },
        600: {
          value: "#e7a24d",
          type: "color",
          description: ""
        },
        700: {
          value: "#e0871a",
          type: "color",
          description: ""
        },
        800: {
          value: "#dd7a01",
          type: "color",
          description: ""
        },
        900: {
          value: "#c76e01",
          type: "color",
          description: ""
        },
        1e3: {
          value: "#b16201",
          type: "color",
          description: ""
        },
        1100: {
          value: "#9f5801",
          type: "color",
          description: ""
        },
        1200: {
          value: "#854901",
          type: "color",
          description: ""
        }
      },
      red: {
        100: {
          value: "#f9e8ea",
          type: "color",
          description: ""
        },
        200: {
          value: "#f2d0d5",
          type: "color",
          description: ""
        },
        300: {
          value: "#ecb9c0",
          type: "color",
          description: ""
        },
        400: {
          value: "#e5a1ab",
          type: "color",
          description: ""
        },
        500: {
          value: "#ea959b",
          type: "color",
          description: ""
        },
        600: {
          value: "#ed6d75",
          type: "color",
          description: ""
        },
        700: {
          value: "#ea5a64",
          type: "color",
          description: ""
        },
        800: {
          value: "#e84853",
          type: "color",
          description: ""
        },
        900: {
          value: "#c52c41",
          type: "color",
          description: ""
        },
        1e3: {
          value: "#bf152c",
          type: "color",
          description: ""
        },
        1100: {
          value: "#ac1328",
          type: "color",
          description: ""
        },
        1200: {
          value: "#991123",
          type: "color",
          description: ""
        }
      },
      green: {
        100: {
          value: "#e5f3e6",
          type: "color",
          description: ""
        },
        200: {
          value: "#cce6cc",
          type: "color",
          description: ""
        },
        300: {
          value: "#b2d9b2",
          type: "color",
          description: ""
        },
        400: {
          value: "#99cd99",
          type: "color",
          description: ""
        },
        500: {
          value: "#80c180",
          type: "color",
          description: ""
        },
        600: {
          value: "#66b466",
          type: "color",
          description: ""
        },
        700: {
          value: "#4da84d",
          type: "color",
          description: ""
        },
        800: {
          value: "#339b33",
          type: "color",
          description: ""
        },
        900: {
          value: "#1a8e1a",
          type: "color",
          description: ""
        },
        1e3: {
          value: "#008200",
          type: "color",
          description: ""
        },
        1100: {
          value: "#007500",
          type: "color",
          description: ""
        },
        1200: {
          value: "#006800",
          type: "color",
          description: ""
        }
      },
      skyView: {
        100: {
          value: "#e4f1ff",
          type: "color",
          description: ""
        },
        200: {
          value: "#c8e1ff",
          type: "color",
          description: ""
        },
        300: {
          value: "#a2ccff",
          type: "color",
          description: ""
        },
        400: {
          value: "#7fb9ff",
          type: "color",
          description: ""
        },
        500: {
          value: "#60a8ff",
          type: "color",
          description: ""
        },
        600: {
          value: "#4699ff",
          type: "color",
          description: ""
        },
        700: {
          value: "#388cf2",
          type: "color",
          description: ""
        },
        800: {
          value: "#2480f1",
          type: "color",
          description: ""
        },
        900: {
          value: "#066fef",
          type: "color",
          description: ""
        },
        1e3: {
          value: "#0562d2",
          type: "color",
          description: ""
        },
        1100: {
          value: "#0559bf",
          type: "color",
          description: ""
        },
        1200: {
          value: "#044ea7",
          type: "color",
          description: ""
        }
      },
      opacityBlack: {
        10: {
          value: "#0000001a",
          type: "color",
          description: ""
        },
        20: {
          value: "#00000033",
          type: "color",
          description: ""
        },
        30: {
          value: "#0000004d",
          type: "color",
          description: ""
        },
        40: {
          value: "#00000066",
          type: "color",
          description: ""
        },
        50: {
          value: "#00000080",
          type: "color",
          description: ""
        },
        60: {
          value: "#00000099",
          type: "color",
          description: ""
        },
        70: {
          value: "#000000b3",
          type: "color",
          description: ""
        },
        80: {
          value: "#000000cc",
          type: "color",
          description: ""
        },
        90: {
          value: "#000000e6",
          type: "color",
          description: ""
        },
        100: {
          value: "#000000",
          type: "color",
          description: ""
        }
      },
      opacityBlackHex: {
        10: {
          value: "#CECECE",
          type: "color",
          description: ""
        }
      },
      neutral: {
        50: {
          value: "#fafafa",
          type: "color",
          description: ""
        },
        100: {
          value: "#f0f0f0",
          type: "color",
          description: ""
        },
        200: {
          value: "#e5e5e5",
          type: "color",
          description: ""
        },
        300: {
          value: "#cccccc",
          type: "color",
          description: ""
        },
        400: {
          value: "#b2b2b2",
          type: "color",
          description: ""
        },
        500: {
          value: "#999999",
          type: "color",
          description: ""
        },
        600: {
          value: "#808080",
          type: "color",
          description: ""
        },
        700: {
          value: "#666666",
          type: "color",
          description: ""
        },
        800: {
          value: "#4d4d4d",
          type: "color",
          description: ""
        },
        900: {
          value: "#333333",
          type: "color",
          description: ""
        },
        1e3: {
          value: "#1a1a1a",
          type: "color",
          description: ""
        },
        1100: {
          value: "#0f0f0f",
          type: "color",
          description: ""
        },
        1200: {
          value: "#000000",
          type: "color",
          description: ""
        },
        "000": {
          value: "#ffffff",
          type: "color",
          description: ""
        }
      },
      opacityWhite: {
        10: {
          value: "#ffffff1a",
          type: "color",
          description: ""
        },
        20: {
          value: "#ffffff33",
          type: "color",
          description: ""
        },
        30: {
          value: "#ffffff4d",
          type: "color",
          description: ""
        },
        40: {
          value: "#ffffff66",
          type: "color",
          description: ""
        },
        50: {
          value: "#ffffff80",
          type: "color",
          description: ""
        },
        60: {
          value: "#ffffff99",
          type: "color",
          description: ""
        },
        70: {
          value: "#ffffffb3",
          type: "color",
          description: ""
        },
        80: {
          value: "#ffffffcc",
          type: "color",
          description: ""
        },
        90: {
          value: "#ffffffe6",
          type: "color",
          description: ""
        },
        100: {
          value: "#ffffff",
          type: "color",
          description: ""
        }
      }
    },
    space: {
      "0x": {
        value: "0px",
        type: "dimension",
        description: ""
      },
      "1x": {
        value: "4px",
        type: "dimension",
        description: ""
      },
      "2x": {
        value: "8px",
        type: "dimension",
        description: ""
      },
      "3x": {
        value: "12px",
        type: "dimension",
        description: ""
      },
      "4x": {
        value: "16px",
        type: "dimension",
        description: ""
      },
      "5x": {
        value: "24px",
        type: "dimension",
        description: ""
      },
      "6x": {
        value: "32px",
        type: "dimension",
        description: ""
      },
      "7x": {
        value: "40px",
        type: "dimension",
        description: ""
      },
      "8x": {
        value: "56px",
        type: "dimension",
        description: ""
      },
      "9x": {
        value: "64px",
        type: "dimension",
        description: ""
      },
      "10x": {
        value: "80px",
        type: "dimension",
        description: ""
      },
      "11x": {
        value: "96px",
        type: "dimension",
        description: ""
      },
      "12x": {
        value: "112px",
        type: "dimension",
        description: ""
      }
    },
    radius: {
      "0x": {
        value: "0px",
        type: "dimension",
        description: ""
      },
      "1x": {
        value: "4px",
        type: "dimension",
        description: ""
      },
      "2x": {
        value: "8px",
        type: "dimension",
        description: ""
      },
      "3x": {
        value: "12px",
        type: "dimension",
        description: ""
      },
      "4x": {
        value: "16px",
        type: "dimension",
        description: ""
      },
      "5x": {
        value: "24px",
        type: "dimension",
        description: ""
      },
      full: {
        value: "400px",
        type: "dimension",
        description: ""
      }
    },
    border: {
      "0x": {
        value: "0px",
        type: "dimension",
        description: ""
      },
      "1x": {
        value: "1px",
        type: "dimension",
        description: ""
      },
      "2x": {
        value: "2px",
        type: "dimension",
        description: ""
      },
      "3x": {
        value: "3px",
        type: "dimension",
        description: ""
      },
      "4x": {
        value: "4px",
        type: "dimension",
        description: ""
      },
      "5x": {
        value: "8px",
        type: "dimension",
        description: ""
      }
    },
    fontFamilies: {
      fordF1Bold: {
        value: "FordF1-Bold",
        type: "fontFamilies"
      },
      fordF1Regular: {
        value: "FordF1-Regular",
        type: "fontFamilies"
      },
      fordF1Medium: {
        value: "FordF1-Medium",
        type: "fontFamilies"
      },
      fordF1Light: {
        value: "FordF1-Light",
        type: "fontFamilies"
      },
      fordF1SemiBold: {
        value: "FordF1-Semibold",
        type: "fontFamilies"
      }
    },
    lineHeights: {
      0: {
        value: "32px",
        type: "lineHeights"
      },
      1: {
        value: "28px",
        type: "lineHeights"
      },
      2: {
        value: "80px",
        type: "lineHeights"
      },
      3: {
        value: "56px",
        type: "lineHeights"
      },
      4: {
        value: "72px",
        type: "lineHeights"
      },
      5: {
        value: "52px",
        type: "lineHeights"
      },
      6: {
        value: "64px",
        type: "lineHeights"
      },
      7: {
        value: "48px",
        type: "lineHeights"
      },
      8: {
        value: "44px",
        type: "lineHeights"
      },
      9: {
        value: "40px",
        type: "lineHeights"
      },
      10: {
        value: "36px",
        type: "lineHeights"
      },
      11: {
        value: "24px",
        type: "lineHeights"
      },
      12: {
        value: "20px",
        type: "lineHeights"
      },
      13: {
        value: "16px",
        type: "lineHeights"
      }
    },
    fontWeights: {
      fordF10: {
        medium: "500",
        value: "Medium",
        type: "fontWeights"
      },
      fordF11: {
        value: "400",
        description: "Regular",
        type: "fontWeights"
      },
      fordF12: {
        value: "300",
        description: "Light",
        type: "fontWeights"
      },
      fordF13: {
        value: "700",
        description: "Bold",
        type: "fontWeights"
      },
      fordF14: {
        value: "600",
        description: "SemiBold",
        type: "fontWeights"
      }
    },
    fontSize: {
      0: {
        value: "12px",
        type: "fontSizes"
      },
      1: {
        value: "14px",
        type: "fontSizes"
      },
      2: {
        value: "16px",
        type: "fontSizes"
      },
      3: {
        value: "20px",
        type: "fontSizes"
      },
      4: {
        value: "24px",
        type: "fontSizes"
      },
      5: {
        value: "28px",
        type: "fontSizes"
      },
      6: {
        value: "32px",
        type: "fontSizes"
      },
      7: {
        value: "36px",
        type: "fontSizes"
      },
      8: {
        value: "40px",
        type: "fontSizes"
      },
      9: {
        value: "44px",
        type: "fontSizes"
      },
      10: {
        value: "48px",
        type: "fontSizes"
      },
      11: {
        value: "54px",
        type: "fontSizes"
      },
      12: {
        value: "62px",
        type: "fontSizes"
      },
      13: {
        value: "70px",
        type: "fontSizes"
      }
    }
  },
  semanticMode1: {
    color: {
      stroke: {
        onLight: {
          moderateDefault: {
            value: "#808080",
            type: "color",
            description: "Use as the default stroke color (borders for most components, i.g. accordions, checkboxes, inputs etc)"
          },
          disabled: {
            value: "#808080",
            type: "color",
            description: "Use for disabled elements with a stroke"
          },
          strongestFocus: {
            value: "#000000",
            type: "color",
            description: "Use for focus rings and focus strokes"
          },
          interactive: {
            value: "#0562d2",
            type: "color",
            description: "Use for interactive elements needing a stroke"
          },
          interactiveHover: {
            value: "#044ea7",
            type: "color",
            description: "Use for strokes that use interactive hover"
          },
          danger: {
            value: "#bf152c",
            type: "color",
            description: "Use for danger/error strokes, borders and dividers"
          },
          caution: {
            value: "#b16201",
            type: "color",
            description: "Use for caution strokes, borders and dividers"
          },
          success: {
            value: "#008200",
            type: "color",
            description: "Use for success strokes, borders and dividers"
          },
          subtleDividers: {
            value: "#b2b2b2",
            type: "color",
            description: "Use for dividers (i.g. tables)"
          },
          strong: {
            value: "#1a1a1a",
            type: "color",
            description: ""
          }
        },
        onDark: {
          moderateDefault: {
            value: "#e5e5e5",
            type: "color",
            description: "Use as the default stroke color for elements on a dark surface"
          },
          disabled: {
            value: "#808080",
            type: "color",
            description: "Use for stroke on disabled elements"
          },
          strongestFocus: {
            value: "#ffffff",
            type: "color",
            description: "Use for focus rings and focus strokes on dark surfaces"
          },
          interactiveHover: {
            value: "#2480f1",
            type: "color",
            description: "Use for hover stroke on interactive elements, on dark surfaces"
          },
          danger: {
            value: "#e84853",
            type: "color",
            description: "Use for danger / error strokes, borders and dividers, on dark surfaces"
          },
          caution: {
            value: "#dd7a01",
            type: "color",
            description: "Use for caution strokes, borders and dividers, on dark surfaces"
          },
          success: {
            value: "#339b33",
            type: "color",
            description: "Use for success strokes, borders and dividers, on dark surfaces"
          },
          interactive: {
            value: "#388cf2",
            type: "color",
            description: "Use for strokes of interactive elements, on dark surfaces"
          },
          subtleDividers: {
            value: "#808080",
            type: "color",
            description: "Use for dividers on dark surfaces (i.g. tables)"
          },
          strong: {
            value: "#f0f0f0",
            type: "color",
            description: ""
          }
        }
      },
      text: {
        onLight: {
          moderateDefault: {
            value: "#333333",
            type: "color",
            description: "Use for most text (body, titles, non-clickable text)"
          },
          strong: {
            value: "#000000",
            type: "color",
            description: "Use for text needing stronger emphasis (button text only)"
          },
          subtle: {
            value: "#666666",
            type: "color",
            description: "Use for secondary text (subtitles, labels, and captions)"
          },
          subtlestDisabled: {
            value: "#808080",
            type: "color",
            description: "Use for disabled text only"
          },
          brandStrongFordBlue: {
            value: "#00095b",
            type: "color",
            description: "Use for display text only"
          },
          interactive: {
            value: "#0562d2",
            type: "color",
            description: "Use for interactive text (links / clickable text)"
          },
          interactiveHover: {
            value: "#044ea7",
            type: "color",
            description: "Use for hover on interactive text"
          },
          danger: {
            value: "#bf152c",
            type: "color",
            description: "Use for danger and error text"
          },
          caution: {
            value: "#b16201",
            type: "color",
            description: "Use for caution text"
          },
          success: {
            value: "#008200",
            type: "color",
            description: "Use for success text"
          },
          brandStrongestTwilight: {
            value: "#00142e",
            type: "color",
            description: ""
          }
        },
        onDark: {
          moderateDefault: {
            value: "#f0f0f0",
            type: "color",
            description: "Use for most text on dark surfaces (body, non-clickable text)"
          },
          subtle: {
            value: "#e5e5e5",
            type: "color",
            description: "Use for disabled text on dark surfaces, sitting on a disabled surface"
          },
          interactive: {
            value: "#388cf2",
            type: "color",
            description: "Use for interactive text on dark surfaces (links / clickable text)"
          },
          interactiveHover: {
            value: "#2480f1",
            type: "color",
            description: "Use for hover on interactive text on dark surfaces"
          },
          danger: {
            value: "#e84853",
            type: "color",
            description: "Use for danger and error text on dark surfaces"
          },
          caution: {
            value: "#dd7a01",
            type: "color",
            description: "Use for caution text on dark surfaces"
          },
          success: {
            value: "#339b33",
            type: "color",
            description: "Use for success text on dark surfaces"
          },
          brandStrongFordBlue: {
            value: "#666b9d",
            type: "color",
            description: "Use for display text"
          },
          subtlestDisabled: {
            value: "#808080",
            type: "color",
            description: ""
          },
          strong: {
            value: "#ffffff",
            type: "color",
            description: ""
          },
          brandStrongestTwilight: {
            value: "#9ca3ad",
            type: "color",
            description: ""
          }
        }
      },
      fill: {
        onLight: {
          highContrastDefault: {
            value: "#ffffff",
            type: "color",
            description: "Use for default fill (surface / background)"
          },
          subtlest: {
            value: "#fafafa",
            type: "color",
            description: "Use for containers using the subtlest neutral color (i.g. surface, backgrounds)"
          },
          strong: {
            value: "#1a1a1a",
            type: "color",
            description: "(Twilight) Use for strong neutral fills (i.g. high emphasis button hover)"
          },
          strongest: {
            value: "#000000",
            type: "color",
            description: "Use for the strongest neutral fills  (i.g. high emphasis primary button)"
          },
          subtle: {
            value: "#e5e5e5",
            type: "color",
            description: "Use for disabled fills"
          },
          interactive: {
            value: "#0562d2",
            type: "color",
            description: "Use for containers needing an interactive color"
          },
          interactiveHover: {
            value: "#044ea7",
            type: "color",
            description: "Use for containers needing a hover interactive color"
          },
          informationalSubtle: {
            value: "#e4f1ff",
            type: "color",
            description: "Use for containers needing a subtle information fill (i.g. background for notifications)"
          },
          informationalStrong: {
            value: "#0562d2",
            type: "color",
            description: "Use for containers needing an information fill (i.g. background for notifications)"
          },
          dangerSubtle: {
            value: "#f9e8ea",
            type: "color",
            description: "Use for containers needing a subtle danger fill (i.g. background for notifications)"
          },
          dangerStrong: {
            value: "#bf152c",
            type: "color",
            description: "Use for containers needing a danger fill"
          },
          cautionSubtle: {
            value: "#fcf2e6",
            type: "color",
            description: "Use for containers needing a subtle caution fill (i.g. background for notifications)"
          },
          cautionStrong: {
            value: "#b16201",
            type: "color",
            description: "Use for containers needing a caution fill"
          },
          successSubtle: {
            value: "#e5f3e6",
            type: "color",
            description: "Use for containers needing a subtle success fill (i.g. background for notifications)"
          },
          successStrong: {
            value: "#008200",
            type: "color",
            description: "Use for containers needing a success fill"
          },
          moderate: {
            value: "#999999",
            type: "color",
            description: "Use for containers using the moderate neutral color (i.g. toggles)"
          },
          brandStrongestTwilight: {
            value: "#00142e",
            type: "color",
            description: "Use for fills using the secondary color"
          },
          brandStrongFordBlue: {
            value: "#00095b",
            type: "color",
            description: ""
          },
          disabled: {
            value: "#e5e5e5",
            type: "color",
            description: ""
          }
        },
        onDark: {
          highContrastDefault: {
            value: "#00142e",
            type: "color",
            description: "Use for default fill (surface / background, on dark surfaces)"
          },
          moderate: {
            value: "#d1d5d9",
            type: "color",
            description: "Use for containers using a neutral moderate color, on dark surfaces"
          },
          informationalSubtle: {
            value: "#e4f1ff",
            type: "color",
            description: "Use for containers using the subtle informational color, on dark surfaces"
          },
          informationalStrong: {
            value: "#2480f1",
            type: "color",
            description: "Use for containers using the informational color, on dark surfaces"
          },
          dangerSubtle: {
            value: "#f9e8ea",
            type: "color",
            description: "Use for containers using the subtle danger color, on dark surfaces"
          },
          dangerStrong: {
            value: "#e84853",
            type: "color",
            description: "Use for containers representing danger, on dark surfaces"
          },
          cautionSubtle: {
            value: "#fcf2e6",
            type: "color",
            description: "Use for containers using the subtle caution color, on dark surfaces"
          },
          cautionStrong: {
            value: "#dd7a01",
            type: "color",
            description: "Use for containers representing caution, on dark surfaces"
          },
          successSubtle: {
            value: "#e5f3e6",
            type: "color",
            description: "Use for containers using the subtle success color, on dark surfaces"
          },
          successStrong: {
            value: "#339b33",
            type: "color",
            description: "Use for containers representing success, on dark surfaces"
          },
          brandStrongFordBlue: {
            value: "#666b9d",
            type: "color",
            description: "Use for fills using the secondary color, on dark surfaces"
          },
          interactiveHover: {
            value: "#2480f1",
            type: "color",
            description: "Use for hovering on interactive fills, on dark surfaces"
          },
          interactive: {
            value: "#388cf2",
            type: "color",
            description: "Use for interactive fill elements, on dark surfaces"
          },
          strong: {
            value: "#f5f6f7",
            type: "color",
            description: "Use for containers using a neutral strong color, on dark surfaces"
          },
          strongest: {
            value: "#ffffff",
            type: "color",
            description: "Use for containers using the neutral strongest color, on dark surfaces"
          },
          subtle: {
            value: "#6b7786",
            type: "color",
            description: "Use for disabled fills, on dark surfaces"
          },
          subtlest: {
            value: "#38485c",
            type: "color",
            description: ""
          },
          brandStrongest: {
            value: "#9ca3ad",
            type: "color",
            description: ""
          },
          disabled: {
            value: "#e5e5e5",
            type: "color",
            description: ""
          }
        }
      },
      icon: {
        onLight: {
          strongDefault: {
            value: "#333333",
            type: "color",
            description: "Use as the default color of icons"
          },
          subtleDisabled: {
            value: "#808080",
            type: "color",
            description: "Use for disabled icons"
          },
          interactive: {
            value: "#0562d2",
            type: "color",
            description: "Use for interactive icons"
          },
          interactiveHover: {
            value: "#044ea7",
            type: "color",
            description: "Use for hover on interactive icons"
          },
          danger: {
            value: "#bf152c",
            type: "color",
            description: "Use for danger and error icons"
          },
          caution: {
            value: "#b16201",
            type: "color",
            description: "Use for caution icons"
          },
          success: {
            value: "#008200",
            type: "color",
            description: "Use for success icons"
          }
        },
        onDark: {
          strongDefault: {
            value: "#f0f0f0",
            type: "color",
            description: "Use for default color of icons, on dark surfaces"
          },
          interactive: {
            value: "#388cf2",
            type: "color",
            description: "Use for interactive icons, on dark surfaces"
          },
          interactiveHover: {
            value: "#2480f1",
            type: "color",
            description: "Use for hover on interactive icons, on dark surfaces"
          },
          danger: {
            value: "#e84853",
            type: "color",
            description: "Use for danger and error icons, on dark surfaces"
          },
          caution: {
            value: "#dd7a01",
            type: "color",
            description: "Use for caution icons, on dark surfaces"
          },
          success: {
            value: "#339b33",
            type: "color",
            description: "Use for success icons, on dark surfaces"
          },
          subtleDisabled: {
            value: "#808080",
            type: "color",
            description: ""
          }
        }
      },
      opacity: {
        scrim: {
          value: "#0000004d",
          type: "color",
          description: "Use for default scrim"
        },
        hoverDefault: {
          value: "#0000001a",
          type: "color",
          description: "Use for components that need an opacity background on hover (cards, lists, selection cards)"
        },
        hoverStrong: {
          value: "#000000b3",
          type: "color",
          description: ""
        }
      }
    },
    radius: {
      none: {
        value: "0px",
        type: "dimension",
        description: ""
      },
      sm: {
        value: "4px",
        type: "dimension",
        description: ""
      },
      md: {
        value: "8px",
        type: "dimension",
        description: ""
      },
      lg: {
        value: "12px",
        type: "dimension",
        description: ""
      },
      xl: {
        value: "16px",
        type: "dimension",
        description: ""
      },
      "2xl": {
        value: "24px",
        type: "dimension",
        description: ""
      },
      full: {
        value: "400px",
        type: "dimension",
        description: ""
      }
    },
    space: {
      none: {
        value: "0px",
        type: "dimension",
        description: ""
      },
      xs: {
        value: "4px",
        type: "dimension",
        description: ""
      },
      sm: {
        value: "8px",
        type: "dimension",
        description: ""
      },
      md: {
        value: "12px",
        type: "dimension",
        description: ""
      },
      lg: {
        value: "16px",
        type: "dimension",
        description: ""
      },
      xl: {
        value: "24px",
        type: "dimension",
        description: ""
      },
      "2xl": {
        value: "32px",
        type: "dimension",
        description: ""
      },
      "3xl": {
        value: "40px",
        type: "dimension",
        description: ""
      },
      "4xl": {
        value: "56px",
        type: "dimension",
        description: ""
      },
      "5xl": {
        value: "64px",
        type: "dimension",
        description: ""
      },
      "6xl": {
        value: "80px",
        type: "dimension",
        description: ""
      },
      "7xl": {
        value: "96px",
        type: "dimension",
        description: ""
      }
    },
    fontFamilies: {
      fordF1Bold: {
        value: "FordF1-Bold",
        type: "fontFamilies"
      },
      fordF1SemiBold: {
        value: "FordF1-SemiBold",
        type: "fontFamilies"
      },
      fordF1Regular: {
        value: "FordF1-Regular",
        type: "fontFamilies"
      },
      fordF1Medium: {
        value: "FordF1-Medium",
        type: "fontFamilies"
      },
      fordF1Light: {
        value: "FordF1-Light",
        type: "fontFamilies"
      }
    },
    lineHeights: {
      0: {
        value: "32px",
        type: "lineHeights"
      },
      1: {
        value: "80px",
        type: "lineHeights"
      },
      2: {
        value: "56px",
        type: "lineHeights"
      },
      3: {
        value: "72px",
        type: "lineHeights"
      },
      4: {
        value: "52px",
        type: "lineHeights"
      },
      5: {
        value: "64px",
        type: "lineHeights"
      },
      6: {
        value: "48px",
        type: "lineHeights"
      },
      7: {
        value: "44px",
        type: "lineHeights"
      },
      8: {
        value: "40px",
        type: "lineHeights"
      },
      9: {
        value: "36px",
        type: "lineHeights"
      },
      10: {
        value: "24px",
        type: "lineHeights"
      },
      11: {
        value: "20px",
        type: "lineHeights"
      },
      12: {
        value: "16px",
        type: "lineHeights"
      }
    },
    fontWeights: {
      light: {
        value: "300",
        description: "Light",
        type: "fontWeights"
      },
      regular: {
        value: "400",
        description: "Regular",
        type: "fontWeights"
      },
      medium: {
        medium: "500",
        value: "Medium",
        type: "fontWeights"
      },
      bold: {
        value: "700",
        description: "Bold",
        type: "fontWeights"
      },
      semiBold: {
        value: "600",
        description: "SemiBold",
        type: "fontWeights"
      }
    },
    fontSize: {
      0: {
        value: "12px",
        type: "fontSizes"
      },
      1: {
        value: "14px",
        type: "fontSizes"
      },
      2: {
        value: "16px",
        type: "fontSizes"
      },
      3: {
        value: "24px",
        type: "fontSizes"
      },
      4: {
        value: "28px",
        type: "fontSizes"
      },
      5: {
        value: "32px",
        type: "fontSizes"
      },
      6: {
        value: "36px",
        type: "fontSizes"
      },
      7: {
        value: "40px",
        type: "fontSizes"
      },
      8: {
        value: "44px",
        type: "fontSizes"
      },
      9: {
        value: "48px",
        type: "fontSizes"
      },
      10: {
        value: "54px",
        type: "fontSizes"
      },
      11: {
        value: "62px",
        type: "fontSizes"
      },
      12: {
        value: "70px",
        type: "fontSizes"
      }
    },
    letterSpacing: {
      0: {
        value: "0px",
        type: "letterSpacing"
      },
      1: {
        value: "0px",
        type: "letterSpacing"
      }
    },
    title: {
      medium: {
        value: {
          fontFamily: "FordF1-Medium",
          fontWeight: "500",
          color: "#333333",
          lineHeight: "32px",
          fontSize: "24px",
          letterSpacing: "0px",
          textDecoration: "none"
        },
        type: "typography"
      },
      bold: {
        value: {
          fontFamily: "FordF1-Bold",
          fontWeight: "700",
          color: "#333333",
          lineHeight: "32px",
          fontSize: "24px",
          letterSpacing: "0px",
          textDecoration: "none"
        },
        type: "typography"
      }
    },
    subtitle: {
      regular: {
        value: {
          fontFamily: "FordF1-Regular",
          fontWeight: "400",
          color: "#666666",
          lineHeight: "28px",
          fontSize: "20px",
          letterSpacing: "0px",
          textDecoration: "none"
        },
        type: "typography"
      }
    },
    display1: {
      regular: {
        large: {
          value: {
            fontFamily: "FordF1-Regular",
            fontWeight: "400",
            color: "#333333",
            lineHeight: "80px",
            fontSize: "70px",
            letterSpacing: "0px",
            textDecoration: "none"
          },
          type: "typography"
        },
        small: {
          value: {
            fontFamily: "FordF1-Regular",
            fontWeight: "400",
            color: "#333333",
            lineHeight: "56px",
            fontSize: "48px",
            letterSpacing: "0px",
            textDecoration: "none"
          },
          type: "typography"
        }
      },
      semibold: {
        large: {
          value: {
            fontFamily: "FordF1-Semibold",
            fontWeight: "600",
            color: "#333333",
            lineHeight: "80px",
            fontSize: "70px",
            letterSpacing: "0px",
            textDecoration: "none"
          },
          type: "typography"
        },
        small: {
          value: {
            fontFamily: "FordF1-Semibold",
            fontWeight: "600",
            color: "#333333",
            lineHeight: "56px",
            fontSize: "48px",
            letterSpacing: "0px",
            textDecoration: "none"
          },
          type: "typography"
        }
      }
    },
    display2: {
      regular: {
        large: {
          value: {
            fontFamily: "FordF1-Regular",
            fontWeight: "400",
            color: "#333333",
            lineHeight: "72px",
            fontSize: "62px",
            letterSpacing: "0px",
            textDecoration: "none"
          },
          type: "typography"
        },
        small: {
          value: {
            fontFamily: "FordF1-Regular",
            fontWeight: "400",
            color: "#333333",
            lineHeight: "52px",
            fontSize: "44px",
            letterSpacing: "0px",
            textDecoration: "none"
          },
          type: "typography"
        }
      },
      semibold: {
        large: {
          value: {
            fontFamily: "FordF1-Semibold",
            fontWeight: "600",
            color: "#333333",
            lineHeight: "72px",
            fontSize: "62px",
            letterSpacing: "0px",
            textDecoration: "none"
          },
          type: "typography"
        },
        small: {
          value: {
            fontFamily: "FordF1-Semibold",
            fontWeight: "600",
            color: "#333333",
            lineHeight: "52px",
            fontSize: "44px",
            letterSpacing: "0px",
            textDecoration: "none"
          },
          type: "typography"
        }
      }
    },
    display3: {
      regular: {
        large: {
          value: {
            fontFamily: "FordF1-Regular",
            fontWeight: "400",
            color: "#333333",
            lineHeight: "64px",
            fontSize: "54px",
            letterSpacing: "0px",
            textDecoration: "none"
          },
          type: "typography"
        },
        small: {
          value: {
            fontFamily: "FordF1-Regular",
            fontWeight: "400",
            color: "#333333",
            lineHeight: "48px",
            fontSize: "40px",
            letterSpacing: "0px",
            textDecoration: "none"
          },
          type: "typography"
        }
      },
      semibold: {
        large: {
          value: {
            fontFamily: "FordF1-Semibold",
            fontWeight: "600",
            color: "#333333",
            lineHeight: "64px",
            fontSize: "54px",
            letterSpacing: "0px",
            textDecoration: "none"
          },
          type: "typography"
        },
        small: {
          value: {
            fontFamily: "FordF1-Semibold",
            fontWeight: "600",
            color: "#333333",
            lineHeight: "48px",
            fontSize: "40px",
            letterSpacing: "0px",
            textDecoration: "none"
          },
          type: "typography"
        }
      }
    },
    headline1: {
      regular: {
        large: {
          value: {
            fontFamily: "FordF1-Regular",
            fontWeight: "400",
            color: "#333333",
            lineHeight: "56px",
            fontSize: "48px",
            letterSpacing: "0px",
            textDecoration: "none"
          },
          type: "typography"
        },
        small: {
          value: {
            fontFamily: "FordF1-Regular",
            fontWeight: "400",
            color: "#333333",
            lineHeight: "44px",
            fontSize: "36px",
            letterSpacing: "0px",
            textDecoration: "none"
          },
          type: "typography"
        }
      },
      semibold: {
        large: {
          value: {
            fontFamily: "FordF1-Semibold",
            fontWeight: "600",
            color: "#333333",
            lineHeight: "56px",
            fontSize: "48px",
            letterSpacing: "0px",
            textDecoration: "none"
          },
          type: "typography"
        },
        small: {
          value: {
            fontFamily: "FordF1-Semibold",
            fontWeight: "600",
            color: "#333333",
            lineHeight: "44px",
            fontSize: "36px",
            letterSpacing: "0px",
            textDecoration: "none"
          },
          type: "typography"
        }
      }
    },
    headline2: {
      regular: {
        large: {
          value: {
            fontFamily: "FordF1-Regular",
            fontWeight: "400",
            color: "#333333",
            lineHeight: "48px",
            fontSize: "40px",
            letterSpacing: "0px",
            textDecoration: "none"
          },
          type: "typography"
        },
        small: {
          value: {
            fontFamily: "FordF1-Regular",
            fontWeight: "400",
            color: "#333333",
            lineHeight: "40px",
            fontSize: "32px",
            letterSpacing: "0px",
            textDecoration: "none"
          },
          type: "typography"
        }
      },
      semibold: {
        large: {
          value: {
            fontFamily: "FordF1-Semibold",
            fontWeight: "600",
            color: "#333333",
            lineHeight: "48px",
            fontSize: "40px",
            letterSpacing: "0px",
            textDecoration: "none"
          },
          type: "typography"
        },
        small: {
          value: {
            fontFamily: "FordF1-Semibold",
            fontWeight: "600",
            color: "#333333",
            lineHeight: "40px",
            fontSize: "32px",
            letterSpacing: "0px",
            textDecoration: "none"
          },
          type: "typography"
        }
      }
    },
    headline3: {
      regular: {
        large: {
          value: {
            fontFamily: "FordF1-Regular",
            fontWeight: "400",
            color: "#333333",
            lineHeight: "40px",
            fontSize: "32px",
            letterSpacing: "0px",
            textDecoration: "none"
          },
          type: "typography"
        },
        small: {
          value: {
            fontFamily: "FordF1-Regular",
            fontWeight: "400",
            color: "#333333",
            lineHeight: "36px",
            fontSize: "28px",
            letterSpacing: "0px",
            textDecoration: "none"
          },
          type: "typography"
        }
      },
      semibold: {
        large: {
          value: {
            fontFamily: "FordF1-Semibold",
            fontWeight: "600",
            color: "#333333",
            lineHeight: "40px",
            fontSize: "32px",
            letterSpacing: "0px",
            textDecoration: "none"
          },
          type: "typography"
        },
        small: {
          value: {
            fontFamily: "FordF1-Semibold",
            fontWeight: "600",
            color: "#333333",
            lineHeight: "36px",
            fontSize: "28px",
            letterSpacing: "0px",
            textDecoration: "none"
          },
          type: "typography"
        }
      }
    },
    headline4: {
      regular: {
        large: {
          value: {
            fontFamily: "FordF1-Medium",
            fontWeight: "500",
            color: "#333333",
            lineHeight: "32px",
            fontSize: "24px",
            letterSpacing: "0px",
            textDecoration: "none"
          },
          type: "typography"
        },
        small: {
          value: {
            fontFamily: "FordF1-Medium",
            fontWeight: "500",
            color: "#333333",
            lineHeight: "28px",
            fontSize: "22px",
            letterSpacing: "0px",
            textDecoration: "none"
          },
          type: "typography"
        }
      },
      semibold: {
        large: {
          value: {
            fontFamily: "FordF1-Semibold",
            fontWeight: "600",
            color: "#333333",
            lineHeight: "32px",
            fontSize: "24px",
            letterSpacing: "0px",
            textDecoration: "none"
          },
          type: "typography"
        },
        small: {
          value: {
            fontFamily: "FordF1-Semibold",
            fontWeight: "600",
            color: "#333333",
            lineHeight: "28px",
            fontSize: "22px",
            letterSpacing: "0px",
            textDecoration: "none"
          },
          type: "typography"
        }
      }
    },
    headline5: {
      regular: {
        large: {
          value: {
            fontFamily: "FordF1-Regular",
            fontWeight: "400",
            color: "#333333",
            lineHeight: "24px",
            fontSize: "20px",
            letterSpacing: "0px",
            textDecoration: "none"
          },
          type: "typography"
        },
        small: {
          value: {
            fontFamily: "FordF1-Regular",
            fontWeight: "400",
            color: "#333333",
            lineHeight: "24px",
            fontSize: "20px",
            letterSpacing: "0px",
            textDecoration: "none"
          },
          type: "typography"
        }
      },
      semibold: {
        large: {
          value: {
            fontFamily: "FordF1-Semibold",
            fontWeight: "600",
            color: "#333333",
            lineHeight: "24px",
            fontSize: "20px",
            letterSpacing: "0px",
            textDecoration: "none"
          },
          type: "typography"
        },
        small: {
          value: {
            fontFamily: "FordF1-Semibold",
            fontWeight: "600",
            color: "#333333",
            lineHeight: "24px",
            fontSize: "20px",
            letterSpacing: "0px",
            textDecoration: "none"
          },
          type: "typography"
        }
      }
    },
    headline6: {
      medium: {
        large: {
          value: {
            fontFamily: "FordF1-Medium",
            fontWeight: "500",
            color: "#333333",
            lineHeight: "24px",
            fontSize: "16px",
            letterSpacing: "0px",
            textDecoration: "none"
          },
          type: "typography"
        },
        small: {
          value: {
            fontFamily: "FordF1-Medium",
            fontWeight: "500",
            color: "#333333",
            lineHeight: "24px",
            fontSize: "16px",
            letterSpacing: "0px",
            textDecoration: "none"
          },
          type: "typography"
        }
      }
    },
    body1: {
      light: {
        value: {
          fontFamily: "FordF1-Light",
          fontWeight: "300",
          color: "#333333",
          lineHeight: "24px",
          fontSize: "16px",
          letterSpacing: "0px",
          textDecoration: "none"
        },
        type: "typography"
      },
      regular: {
        value: {
          fontFamily: "FordF1-Regular",
          fontWeight: "400",
          color: "#333333",
          lineHeight: "24px",
          fontSize: "16px",
          letterSpacing: "0px",
          textDecoration: "none"
        },
        type: "typography"
      },
      medium: {
        value: {
          fontFamily: "FordF1-Medium",
          fontWeight: "500",
          color: "#333333",
          lineHeight: "24px",
          fontSize: "16px",
          letterSpacing: "0px",
          textDecoration: "none"
        },
        type: "typography"
      },
      semibold: {
        value: {
          fontFamily: "FordF1-Semibold",
          fontWeight: "600",
          color: "#333333",
          lineHeight: "24px",
          fontSize: "16px",
          letterSpacing: "0px",
          textDecoration: "none"
        },
        type: "typography"
      },
      bold: {
        value: {
          fontFamily: "FordF1-Bold",
          fontWeight: "700",
          color: "#333333",
          lineHeight: "24px",
          fontSize: "16px",
          letterSpacing: "0px",
          textDecoration: "none"
        },
        type: "typography"
      },
      underline: {
        value: {
          fontFamily: "FordF1-Regular",
          fontWeight: "400",
          color: "#333333",
          lineHeight: "24px",
          fontSize: "16px",
          letterSpacing: "0px",
          textDecoration: "underline"
        },
        type: "typography"
      },
      superscript: {
        value: {
          fontFamily: "FordF1-Regular",
          fontWeight: "400",
          color: "#333333",
          lineHeight: "24px",
          fontSize: "16px",
          letterSpacing: "0px",
          textDecoration: "underline"
        },
        type: "typography"
      }
    },
    body2: {
      light: {
        value: {
          fontFamily: "FordF1-Light",
          fontWeight: "300",
          color: "#333333",
          lineHeight: "20px",
          fontSize: "14px",
          letterSpacing: "0px",
          textDecoration: "none"
        },
        type: "typography"
      },
      regular: {
        value: {
          fontFamily: "FordF1-Regular",
          fontWeight: "400",
          color: "#333333",
          lineHeight: "20px",
          fontSize: "14px",
          letterSpacing: "0px",
          textDecoration: "none"
        },
        type: "typography"
      },
      medium: {
        value: {
          fontFamily: "FordF1-Medium",
          fontWeight: "500",
          color: "#333333",
          lineHeight: "20px",
          fontSize: "14px",
          letterSpacing: "0px",
          textDecoration: "none"
        },
        type: "typography"
      },
      semibold: {
        value: {
          fontFamily: "FordF1-Semibold",
          fontWeight: "600",
          color: "#333333",
          lineHeight: "20px",
          fontSize: "14px",
          letterSpacing: "0px",
          textDecoration: "none"
        },
        type: "typography"
      },
      bold: {
        value: {
          fontFamily: "FordF1-Bold",
          fontWeight: "700",
          color: "#333333",
          lineHeight: "20px",
          fontSize: "14px",
          letterSpacing: "0px",
          textDecoration: "none"
        },
        type: "typography"
      },
      underline: {
        value: {
          fontFamily: "FordF1-Regular",
          fontWeight: "400",
          color: "#333333",
          lineHeight: "20px",
          fontSize: "14px",
          letterSpacing: "0px",
          textDecoration: "underline"
        },
        type: "typography"
      },
      superscript: {
        value: {
          fontFamily: "FordF1-Regular",
          fontWeight: "400",
          color: "#333333",
          lineHeight: "20px",
          fontSize: "14px",
          letterSpacing: "0px",
          textDecoration: "none"
        },
        type: "typography"
      }
    },
    caption: {
      regular: {
        value: {
          fontFamily: "FordF1-Regular",
          fontWeight: "400",
          color: "#666666",
          lineHeight: "16px",
          fontSize: "12px",
          letterSpacing: "0px",
          textDecoration: "none"
        },
        type: "typography"
      },
      medium: {
        value: {
          fontFamily: "FordF1-Medium",
          fontWeight: "500",
          color: "#666666",
          lineHeight: "16px",
          fontSize: "12px",
          letterSpacing: "0px",
          textDecoration: "none"
        },
        type: "typography"
      },
      semibold: {
        value: {
          fontFamily: "FordF1-Semibold",
          fontWeight: "600",
          color: "#666666",
          lineHeight: "16px",
          fontSize: "12px",
          letterSpacing: "0px",
          textDecoration: "none"
        },
        type: "typography"
      },
      bold: {
        value: {
          fontFamily: "FordF1-bold",
          fontWeight: "700",
          color: "#666666",
          lineHeight: "16px",
          fontSize: "12px",
          letterSpacing: "0px",
          textDecoration: "none"
        },
        type: "typography"
      },
      underline: {
        value: {
          fontFamily: "FordF1-Regular",
          fontWeight: "400",
          color: "#666666",
          lineHeight: "16px",
          fontSize: "12px",
          letterSpacing: "0px",
          textDecoration: "underline"
        },
        type: "typography"
      },
      superscript: {
        value: {
          fontFamily: "FordF1-Regular",
          fontWeight: "400",
          color: "#666666",
          lineHeight: "16px",
          fontSize: "12px",
          letterSpacing: "0px",
          textDecoration: "underline"
        },
        type: "typography"
      }
    },
    textTransform: {
      none: {
        value: "none",
        type: "textTransform"
      }
    },
    textDecoration: {
      none: {
        value: "none",
        type: "textDecoration"
      },
      underline: {
        value: "underline",
        type: "textDecoration"
      }
    }
  },
  componentMode1: {
    button: {
      primary: {
        onLight: {
          default: {
            value: "#066fef",
            type: "color",
            description: ""
          },
          hover: {
            value: "#044ea7",
            type: "color",
            description: ""
          }
        },
        onDark: {
          default: {
            value: "#066fef",
            type: "color",
            description: ""
          },
          interactiveHover: {
            value: "#0562d2",
            type: "color",
            description: ""
          },
          disabled: {
            value: "#cccccc",
            type: "color",
            description: ""
          }
        }
      }
    },
    rating: {
      onLight: {
        default: {
          value: "#066fef",
          type: "color",
          description: ""
        },
        hover: {
          value: "#044ea7",
          type: "color",
          description: ""
        }
      },
      onDark: {
        default: {
          value: "#066fef",
          type: "color",
          description: ""
        },
        hover: {
          value: "#0562d2",
          type: "color",
          description: ""
        },
        disabled: {
          value: "#cccccc",
          type: "color",
          description: ""
        }
      }
    },
    radio: {
      onLight: {
        default: {
          value: "#066fef",
          type: "color",
          description: ""
        },
        hover: {
          value: "#044ea7",
          type: "color",
          description: ""
        }
      },
      onDark: {
        default: {
          value: "#066fef",
          type: "color",
          description: ""
        },
        hover: {
          value: "#0562d2",
          type: "color",
          description: ""
        },
        disabled: {
          value: "#cccccc",
          type: "color",
          description: ""
        }
      }
    },
    checkbox: {
      onLight: {
        default: {
          value: "#066fef",
          type: "color",
          description: ""
        },
        hover: {
          value: "#044ea7",
          type: "color",
          description: ""
        }
      },
      onDark: {
        default: {
          value: "#066fef",
          type: "color",
          description: ""
        },
        hover: {
          value: "#0562d2",
          type: "color",
          description: ""
        },
        disabled: {
          value: "#cccccc",
          type: "color",
          description: ""
        }
      }
    },
    toggle: {
      onLight: {
        default: {
          value: "#066fef",
          type: "color",
          description: ""
        },
        hover: {
          value: "#044ea7",
          type: "color",
          description: ""
        }
      },
      onDark: {
        default: {
          value: "#066fef",
          type: "color",
          description: ""
        },
        hover: {
          value: "#0562d2",
          type: "color",
          description: ""
        },
        disabled: {
          value: "#cccccc",
          type: "color",
          description: ""
        }
      }
    },
    stepper: {
      onLight: {
        default: {
          value: "#066fef",
          type: "color",
          description: ""
        },
        hover: {
          value: "#044ea7",
          type: "color",
          description: ""
        }
      },
      onDark: {
        default: {
          value: "#066fef",
          type: "color",
          description: ""
        },
        hover: {
          value: "#0562d2",
          type: "color",
          description: ""
        },
        disabled: {
          value: "#cccccc",
          type: "color",
          description: ""
        }
      }
    },
    segmentedControl: {
      onLight: {
        default: {
          value: "#066fef",
          type: "color",
          description: ""
        },
        hover: {
          value: "#044ea7",
          type: "color",
          description: ""
        }
      },
      onDark: {
        default: {
          value: "#066fef",
          type: "color",
          description: ""
        },
        hover: {
          value: "#0562d2",
          type: "color",
          description: ""
        },
        disabled: {
          value: "#cccccc",
          type: "color",
          description: ""
        }
      }
    },
    inputs: {
      onDark: {
        disabled: {
          value: "#cccccc",
          type: "color",
          description: ""
        }
      }
    }
  }
};
export {
  e as f
};
